// extracted by mini-css-extract-plugin
module.exports = {"profileSlider":"profile-slider-module--profile-slider--22l1e"};